import { getMeasuresList, } from '../config/services/measures';
import _ from 'lodash'

export const fetchMeasureList = async(id) => {
    let params = { dataSetId: id, search: '' }
    return getMeasuresList(params)
        .then((res) => {
            return res?.result;
        })
}

export const applyFilterOnLinkedReports = async (linkedReportsArray, filtersApplied) => {
    let clonedLinkedReportsArray = _.cloneDeep(linkedReportsArray)
    let clonedFiltersApplied = _.cloneDeep(filtersApplied)
    clonedLinkedReportsArray?.map(async reportObj => {
        let { reportId } = reportObj
        if(reportId){
            let measureListForDataset = await fetchMeasureList(reportId?.dataSetId);

            clonedFiltersApplied?.map(filterObj => {

                if (filterObj?.member) {
                    let filterMeasure = filterObj?.member?.split('.')[1]
                    let filterMeasureFound = false

                    if (filterMeasure) {
                        filterMeasureFound = measureListForDataset?.find(obj => obj.name === filterMeasure)
                    }

                    if (filterMeasureFound) {
                        let filterData = {
                            operator: filterObj?.operator ?? "equals",
                            values: filterObj?.values,
                            linkedReportFilter: true
                        }

                        let dataSetName = null;
                        if (reportId?.dimensions?.length > 0) {
                            dataSetName = reportId?.dimensions[0]?.fieldName?.split('.')[0];
                        }
                        else if (reportId?.measures?.length > 0) {
                            dataSetName = reportId?.measures[0]?.fieldName?.split('.')[0];
                        }

                        if (dataSetName)
                            filterData.member = dataSetName + "." + filterMeasureFound?.name;

                        if (reportId?.reportFilters?.length) {
                            let filterExistIndex = reportId?.reportFilters?.findIndex(obj => obj.member === filterData?.member);

                            if (filterExistIndex < 0) {
                                reportId?.reportFilters?.push(filterData)
                            }
                            else {
                                reportId.reportFilters[filterExistIndex] = { ...filterData }
                            }
                        }
                        else {
                            reportId.reportFilters = [filterData]
                        }


                    }
                }
                return filterObj
            })
        }
        
    })

    return clonedLinkedReportsArray
}
